<template>
  <v-card flat v-if="!loading" style="width: 100%;">
    <template v-if="this.orders.length !== 0">
      <div style="text-align: right;" class="mr-2">
        <v-btn outline small @click="refreshData" color="primary" style="min-width: 50px;">
          <i class="fa fa-refresh" style="font-size: 17px;" aria-hidden="true"></i
        ></v-btn>
      </div>

      <v-layout row wrap>
        <v-flex v-for="(item, index) in orders" :key="index">
          <v-card flat class="white pb-2 mb-1 pl-2 pa-2">
            <v-layout wrap>
              <v-flex xs6 sm7 class="pl-3 pr-3 pt-2 pb-2">
                <label>{{ $t('Order No.') }} {{ item.id }}</label>
              </v-flex>

              <v-flex xs6 sm5 class="pl-3 pr-3 pt-2 pb-2 text-xs-right">
                <div
                  class="text-xs-center"
                  style="padding: 0px 3px;border: solid 1px; display: block;"
                >
                  {{ $t(item.status) }}
                </div>
              </v-flex>

              <v-flex xs9 class="pl-3 pr-3 pt-2 pb-2">
                <label> {{ dateFormat(item.timestamp) }}</label>
              </v-flex>
              <v-flex xs3 class="pl-3 pr-3 pt-2 pb-2 text-xs-right" @click="toggle(index)">
                <label>
                  <i class="fa fa-sort-asc primary-color" v-if="item.toggle" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc primary-color" v-else aria-hidden="true"></i
                ></label>
              </v-flex>
            </v-layout>
            <v-layout wrap v-show="item.toggle">
              <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
                <edit-address
                  v-if="!loadUpdateOrder"
                  v-model="item.nameaddress"
                  :hasCopy="true"
                  @edited="updateOrder(item)"
                ></edit-address>
                <div v-else class="spinner text-xs-center">
                  <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
                </div>
              </v-flex>
              <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
                <h3>{{ $t('สินค้า') }}</h3>
              </v-flex>
              <template v-if="!loadUpdateOrder">
                <template v-for="(product, i) in item.productdetail">
                  <v-layout wrap :key="`product_${i}`">
                    <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
                      <div style="display: flex;">
                        <img
                          :src="product.photourl"
                          aspect-ratio="1"
                          alt
                          class="grey lighten-2"
                          style="width: 30px; height: 30px;"
                        />
                        <label class="ml-2 primary-color">
                          {{ product.name }}
                          <span style="color:#000"> ({{ product.option }})</span></label
                        >
                        <label class="ml-2" style="color:#000">x{{ product.quantity }}</label>
                      </div>
                    </v-flex>
                    <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
                      <label class="ml-2"> ฿{{ product.price | decimalFormat }}</label>
                    </v-flex>
                  </v-layout>
                </template>
              </template>
              <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
                <label class="ml-2"> {{ $t('Subtotal') }}</label>
              </v-flex>
              <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
                <label class="ml-2">
                  ฿{{
                    (item.total - (item.shippingcharge ? item.shippingcharge : 0)) | decimalFormat
                  }}
                </label>
              </v-flex>
              <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
                <label class="ml-2"> {{ $t('Shipping fee') }}</label>
              </v-flex>
              <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
                <label class="ml-2"> ฿{{ item.shippingcharge | decimalFormat }}</label>
              </v-flex>
              <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
                <label class="ml-2"> {{ $t('Total') }}</label>
              </v-flex>
              <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
                <label class="ml-2"> ฿{{ JSON.parse(item.amount) | decimalFormat }}</label>
              </v-flex>
              <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
                <img
                  v-if="item.shippingtype == 'normal'"
                  src="/static/img/assets/payment/normal_charge_logo.png"
                  alt
                  class="responsive-img"
                  style="max-height: 50px"
                />
                <img
                  v-else-if="item.shippingtype == 'ems'"
                  src="/static/img/assets/payment/ems_charge_logo.png"
                  alt
                  class="responsive-img"
                  style="max-height: 50px"
                />
                <img
                  v-else-if="item.shippingtype == 'kerry'"
                  src="/static/img/assets/payment/kerry_charge_logo.png"
                  alt
                  class="responsive-img"
                  style="max-height: 50px"
                />
                <template v-else>
                  <img
                    :src="'/static/img/assets/payment/' + item.shippingtype + '_logo.png'"
                    alt
                    class="responsive-img"
                    style="max-height: 50px"
                  />
                  <div v-if="item.shippingtype == 'cod_charge'">
                    {{ $t('cod_charge') }}
                  </div>
                </template>
              </v-flex>
              <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2" style="align-self: center;">
                <label class="ml-2"> {{ $t(item.shippingtype) }}</label>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <infinite-loading v-if="orders.length" spinner="spiral" @infinite="infiniteScroll">
        <span slot="no-more"></span
      ></infinite-loading>
    </template>
    <div class="text-xs-center pa-3" v-else>
      <span>ไม่พบรายการสั่งซื้อ</span>
    </div>
  </v-card>
  <div v-else class="spinner text-xs-center mt-3">
    <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import InfiniteLoading from 'vue-infinite-loading'
import api from '@/api'
import EditAddress from '../template/ecommerce/EditAddress.vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loadUpdateOrder: false,
      orders: [],
      offset: 0,
      loading: true
    }
  },
  components: { InfiniteLoading, EditAddress },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang'
    })
  },
  created() {
    this.fetchData()
  },
  mounted() {},
  methods: {
    updateOrder(order) {
      // console.log(order)

      let vm = this
      vm.loadUpdateOrder = true
      if (order) {
        order.productdetail = JSON.stringify(order.productdetail)
        api.editOrderSummary(order, function(error, response) {
          if (error) {
            console.error(error)
            vm.loadUpdateOrder = false
            return
          }
          if (response.responsecode === 200) {
            order.productdetail = JSON.parse(order.productdetail)
          }
          vm.loadUpdateOrder = false
        })
      }
    },

    async fetchData() {
      this.infiniteScroll()
    },
    toggle(index) {
      this.orders[index].toggle = !this.orders[index].toggle
    },
    async infiniteScroll($state) {
      try {
        var { result } = await api.liveChatUserOrders({
          pageid: this.$store.state.livechat.pageid,
          userid: this.$store.state.livechat.currentUser.userid,
          limit: 5,
          offset: this.offset
        })
        if (result) {
          setTimeout(() => {
            this.loading = false
            if (result.length >= 1) {
              result.forEach(item => {
                item.toggle = false
                item.productdetail = JSON.parse(item.productdetail)
                this.orders.push(item)
              })
              this.offset += 5
              if ($state) $state.loaded()
            } else {
              if ($state) $state.complete()
            }
          }, 500)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    dateFormat(date) {
      return dayjs(date)
        .locale(this.currentLang)
        .format('dddd, MMMM D, YYYY h:mm A')
    },
    refreshData() {
      this.orders = []
      this.offset = 0
      this.loading = true
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.theme--light.v-card {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-order-summary.vue